import mixin from './mixin'
import BackToTop from '../../components/common/BackToTop.js'
const winWidth = document.documentElement.clientWidth
const videoHeight = Math.floor(winWidth / 1.65)

export default {
  el: '.wrap',
  name: 'app',
  mixins: [mixin],
  data() {
    return {
      IS_MOBILE: true,
      winWidth,
      videoHeight
    }
  },
  components: {
    'back-to-top': BackToTop
  },
  mounted() {
    window.pandora.use(['share', 'clipboard'], function(Share, Clipboard) {
      new Share({
        element: '.v-share',
        showLabel: true,
        shareList: 'tsina,qzone,tqq,qq,renren',
        shape: 'cir',
        size: 'l'
      })
      new Clipboard({
        element: '.btn-copy',
        text: window.location.href
      })
    })
    new window.Swiper('.js-swiper-free',{
        freeMode : true,
        slidesPerView : 'auto'
    });
  }
}